import { PageLoadingOverlayDirective } from './common/directives/page-loading-overlay.directive';
import { providePrimeNG } from 'primeng/config';
import { saraTheme } from './sara-theme';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppBaseModule } from './common/modules/app-base.module';
import { AppLayoutModule } from './common/modules/app-layout/app-layout.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { DialogService } from 'primeng/dynamicdialog';
import { TestSecureDataComponent } from './feature/test-secure-data/test-secure-data.component'
import { PrimeNGModule } from './common/modules/primeng.module';
import { SaraPlusFormModule } from '@sp-forms/saraplus-ngx-forms';
import { DefaultComponent } from './feature/default/default.component';
import { AuthHeaderInterceptor } from './common/interceptors/auth-header.interceptor';
import { PayloadEncryptionInterceptor } from './common/interceptors/payload-encryption.interceptor';
import { LoadingIndicatorInterceptor } from './common/interceptors/loading-indicator.interceptor';
import { HttpErrorInterceptor } from './common/interceptors/http-error.interceptor';
import { NotFoundComponent } from './feature/not-found/not-found.component';
import { PinViewComponent } from './feature/pin-view/pin-view.component';
import { CustomerInformationCollectionComponent } from './feature/customer-information-collection/customer-information-collection.component';
import { LinkExpiredComponent } from './feature/link-expired/link-expired.component';
import { EmailVerificationModule } from './common/modules/email-verification/email-verification.component';
import { PhoneVerificationModule } from './common/modules/phone-verification/phone-verification.component';
import { IconWrapperModule } from './common/modules/icon-wrapper/icon-wrapper.component';
import { ExternalDataService } from './common/services/external-data.service';
import { CommonComponentModule } from './common/modules/Common-Components/common-component.module';
import { CreditInformationComponent } from './feature/credit-information/credit-information.component';
import { CustomerWaitingComponent } from './feature/customer-waiting/customer-waiting.component';
import { TermsConditionsComponent } from './feature/terms-conditions/terms-conditions.component';
import { OrderCheckListComponent } from './feature/order-checklist/order-checklist.component';
import { FirstPartyVerificationComponent } from './feature/first-party-verification/first-party-verification.component';
import { NcvcQuestionnaireComponent } from './feature/ncvc-questionnaire/ncvc-questionnaire.component';
import { CustomerAccountSetupComponent } from './feature/customer-account-setup/customer-account-setup/customer-account-setup.component';
import { TranslationModule } from './common/modules/translation.module';
import { OutstandingBalanceComponent } from './feature/outstanding-balance/outstanding-balance.component';
import { PaymentInformationEntryComponent } from './feature/payment-information-entry/payment-information-entry.component';
import { AchBillingComponent } from './feature/payment-information-entry/ach-billing/ach-billing.component';
import { CreditCardBillingComponent } from './feature/payment-information-entry/credit-card-billing/credit-card-billing.component';
import { AutopayPaperlessPaymentComponent } from './feature/payment-information-entry/autopay-paperless-payment/autopay-paperless-payment.component';
import * as Sentry from "@sentry/angular";
import { WindstreamCustomerAccountSetupComponent } from './feature/windstream-customer-account-setup/windstream-customer-account-setup.component';
import { WirelessSetupComponent } from './feature/wireless-setup/wireless-setup.component';
import { WirelessUpgradePaymentComponent } from './feature/wireless-upgrade-payment/wireless-upgrade-setup.component';
import { LocationRequiredComponent } from './feature/location-required/location-required.component';
import { AltAutopayPaperlessPaymentComponent } from './feature/payment-information-entry/alt-autopay-paperless-payment/alt-autopay-paperless-payment.component';
import { ProviderPaymentIframeComponent } from './feature/payment-information-entry/provider-payment-iframe/provider-payment-iframe.component';
import { WirelessAccountAuthenticationComponent } from './feature/wireless-account-authentication/wireless-account-authentication.component';
import { AccountLookupComponent } from './feature/wireless-account-authentication/account-lookup/account-lookup.component';
import { OtpDeliveryComponent } from './feature/wireless-account-authentication/otp-delivery/otp-delivery.component';
import { OtpVerificationComponent } from './feature/wireless-account-authentication/otp-verification/otp-verification.component';
import { MobileBusinessAgreementComponent } from './feature/mobile-business-agreement/mobile-business-agreement.component';

@NgModule({ declarations: [
        AppComponent,
        TestSecureDataComponent,
        DefaultComponent,
        NotFoundComponent,
        PinViewComponent,
        CustomerInformationCollectionComponent,
        LinkExpiredComponent,
        CreditInformationComponent,
        CustomerWaitingComponent,
        TermsConditionsComponent,
        OrderCheckListComponent,
        FirstPartyVerificationComponent,
        NcvcQuestionnaireComponent,
        CustomerAccountSetupComponent,
        OutstandingBalanceComponent,
        PaymentInformationEntryComponent,
        CreditCardBillingComponent,
        AchBillingComponent,
        AutopayPaperlessPaymentComponent,
        AltAutopayPaperlessPaymentComponent,
        ProviderPaymentIframeComponent,
        WindstreamCustomerAccountSetupComponent,
        WirelessSetupComponent,
        WirelessUpgradePaymentComponent,
        LocationRequiredComponent,
        WirelessAccountAuthenticationComponent,
        AccountLookupComponent,
        OtpDeliveryComponent,
        OtpVerificationComponent,
        MobileBusinessAgreementComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        AppBaseModule,
        AppLayoutModule,
        BrowserAnimationsModule,
        BrowserModule,
        PrimeNGModule,
        PageLoadingOverlayDirective,
        SaraPlusFormModule,
        EmailVerificationModule,
        PhoneVerificationModule,
        IconWrapperModule,
        CommonComponentModule,
        TranslationModule], providers: [
        providePrimeNG({ theme: { preset: saraTheme, options: { darkModeSelector: false } } }),
        DialogService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthHeaderInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: PayloadEncryptionInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoadingIndicatorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        ExternalDataService,
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
              showDialog: false, // Set to true to show user a report dialog
            }),
        }
    ] })
export class AppModule { }